export default __webpack_public_path__ + "static/bv-mob-313e3dbe17454746da6604b87f56f7c1.png";